<template>
  <div class="templates-terms-modal">
    <div class="modal-backdrop"></div>

    <div class="modal fade show d-block">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Bem-vindo ao programa M60</h3>
          </div>
          <div class="modal-body">
            <p>
              Antes de começar a usar a plataforma, é importante que você leia e
              aceite os Termos de Uso.
            </p>
            <p>
              Por favor, role o texto até o final para habilitar a opção de
              aceite. A utilização da plataforma só é permitida após a
              concordância com os termos.
            </p>

            <terms-text />

            <b-checkbox v-model="check" class="mt-4">
              <strong>Eu li e estou de acordo com os Termos e condições</strong>
            </b-checkbox>
          </div>
          <form
            @submit.prevent="submit"
            class="modal-footer d-flex justify-content-end"
          >
            <button
              class="btn btn-primary px-5"
              :class="{ disabled }"
              :disabled="disabled"
            >
              <loading :show="loading">
                Confirmar
              </loading>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TermsText from "../home/TermsText.vue";

export default {
  components: {
    TermsText
  },
  data() {
    return {
      check: false,
      loading: false
    };
  },
  computed: {
    disabled() {
      return !this.check || this.loading;
    }
  },
  methods: {
    submit() {
      this.loading = true;
      window.axios
        .post("accounts/accept-terms/")
        .then(() => {
          this.$emit("close");
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro ao aceitar os termos");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.templates-terms-modal {
  h3 {
    font-size: 32px;
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
    letter-spacing: 0.1px;
  }

  .modal-body {
    max-height: calc(100dvh - 210px);
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .modal-footer {
    border: none;

    .disabled {
      opacity: 0.5;
      filter: grayscale(100%);
    }
  }
}
</style>
